import { getStoredFakeData } from '@/components/shared/DevPanel/DevPanel.helpers';
import { configBase } from '@/config/base';

const stored = getStoredFakeData();

export function consoleLog(type: LogColorType, text: string, data?: any) {
    if (configBase.devMode.enabled && stored.log) {
        const style = getLogColorStyle(type);
        console.log(`%c [${type}] ${text}`, style, data ?? '');
    }
}

function getLogColorStyle(type: LogColorType) {
    const styling = logColors.find((x) => x.type === type);
    return styling ? `background: ${styling.background}; color: ${styling.color}` : '';
}

export enum LogColorType {
    Error = 'Error',
    Travellers = 'Travellers',
    TravellersError = 'TravellersError',
    Spotlights = 'Spotlights',
    HotelWidget = 'HotelWidget',
    TripWidget = 'TripWidget',
    RentalCarWidget = 'RentalCarWidget',
    CartSessionUpdate = 'CartSessionUpdate',
    LoanApplication = 'LoanApplication',
    Ryanair = 'Ryanair',
}

interface LogColor {
    type: LogColorType;
    background: string;
    color: string;
}

const logColors: LogColor[] = [
    {
        type: LogColorType.Error,
        color: '#fff',
        background: 'red',
    },
    {
        type: LogColorType.Travellers,
        color: '#fff',
        background: 'indigo',
    },
    {
        type: LogColorType.TravellersError,
        color: '#000',
        background: 'orange',
    },
    {
        type: LogColorType.Spotlights,
        color: '#000',
        background: 'yellow',
    },
    {
        type: LogColorType.HotelWidget,
        color: '#fff',
        background: 'green',
    },
    {
        type: LogColorType.TripWidget,
        color: '#fff',
        background: 'purple',
    },
    {
        type: LogColorType.RentalCarWidget,
        color: '#000',
        background: 'pink',
    },
    {
        type: LogColorType.CartSessionUpdate,
        color: '#000',
        background: 'beige',
    },
    {
        type: LogColorType.LoanApplication,
        color: '#fff',
        background: 'mediumpurple',
    },
    {
        type: LogColorType.Ryanair,
        color: '#fff',
        background: 'blue',
    },
];
